/* Where the hosted pay page sends the member back to. */

/**
 * Where the member came from, when the member web sent them here (`?back=`).
 * Only a path inside the member app is honoured — this page is public, and an
 * arbitrary URL here would make it an open redirect. A link opened from
 * WhatsApp or the mobile app carries none, and gets no back button.
 */
export function asBack(path: string | null): { path: string; label: string } | null {
  if (!path || !path.startsWith('/app/') || path.startsWith('//') || path.includes('\\')) return null;
  return { path, label: path.startsWith('/app/bookings') ? 'Back to my bookings' : 'Back to Gympe' };
}

/**
 * Read once, on arrival. A redirect gateway (PhonePe) returns to the bare page
 * URL and the return parameters are then cleaned off it, so the target is kept
 * per link for the rest of the tab's life.
 */
export function backTarget(token: string): { path: string; label: string } | null {
  const key = `pay-back:${token}`;
  const fromUrl = asBack(new URLSearchParams(window.location.search).get('back'));
  try {
    if (fromUrl) sessionStorage.setItem(key, fromUrl.path);
    else return asBack(sessionStorage.getItem(key));
  } catch {
    /* storage blocked — the back button is a convenience */
  }
  return fromUrl;
}
